<template>


    <div>
        <v-toolbar flat color="white" v-if="error">
            <v-spacer></v-spacer>

            <v-alert :value="error" type="error" transition="scale-transition">
                {{ errorMessage }}

                <v-btn small flat icon color="white" @click="closeAlert">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-alert>


        </v-toolbar>

        <v-card flat>
            <v-card-title>
                <p class="font-weight-bold subheading congatec-gray">{{ getRightTypeHeader }}</p>
                <v-spacer></v-spacer>

            </v-card-title>

            <v-data-table :headers="headers"
                          :items="rights"
                          :search="search"
                          :rows-per-page-items="rowsPerPage">
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left width-right-name">{{ props.item.name }}</td>
                    <td class="text-xs-left width-right-description">{{ props.item.description }}</td>
                    <td class="text-xs-left">
                        <v-btn color="green" dark small @click="onEditRight(props.item)">
                            <v-icon v-if="updateRight" class="mr-2">edit</v-icon>
                            <v-icon v-else class="mr-2">far fa-eye</v-icon>
                        </v-btn>

                        <v-btn color="red" dark small @click="onDeleteRight(props.item)" v-if="deleteRight">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>

            <v-toolbar flat color="white" style="height: 0px">
                <ConfirmRightDeletionModal v-model="showDeletionModal" :isAppRight="appRight" :right="right"/>

                <ShowRightModal v-model="showRightModal" :editMode="editMode" :disabled="disabled"
                                :isAppRight="appRight" :right="right"/>
            </v-toolbar>
        </v-card>
    </div>

</template>


<script>

    import ShowRightModal from './modals/ShowRightModal.vue'
    import rightinterface from "../../../interfaces/rightinterface";
    import {EventBus} from "../../../eventbus";
    import ConfirmRightDeletionModal from './modals/ConfirmRightDeletionModal';

    export default {
        name: "RoleList",

        components: {
            ConfirmRightDeletionModal,
            ShowRightModal
        },

        props: {
            appRight: Boolean,
            search: String
        },

        created() {
            this.initialize();
            this.initializeRights();
        },

        data: () => ({
            rowsPerPage: [10, 25, 50],

            headers: [
                {text: 'Name', value: 'name'},
                {text: 'Description', value: 'description'},
                {text: 'Options', value: 'options'}
            ],

            rights: [],

            right: {
                rightId: null,
                name: null,
                description: null
            },

            emptyRight: {
                rightId: null,
                name: null,
                description: null
            },

            deleteRight: false,
            updateRight: false,

            error: false,
            errorMessage: null,

            showDeletionModal: false,
            showRightModal: false,
            editMode: false,
            disabled: false
        }),

        mounted() {
            EventBus.$on('onRefreshRightList', () => {
                this.initialize();
            });
            EventBus.$on('rightDeletionConfirmed', () => {
                this.initialize();
                this.right = Object.assign({}, this.emptyRight);
                this.editMode = false;
                this.showDeletionModal = false;
            });
            EventBus.$on('rightDeletionClosed', () => {
                this.initialize();
                this.right = Object.assign({}, this.emptyRight);
                this.editMode = false;
                this.showDeletionModal = false;
            });
            EventBus.$on('rightModalClosed', () => {
                this.initialize();
                this.right = Object.assign({}, this.emptyRight);
                this.editMode = false;
                this.showRightModal = false;
                this.disabled = false;
            });

        },

        methods: {
            onEditRight(right) {
                let clonedRight = {
                    rightId: right.rightId,
                    name: right.name,
                    description: right.description
                };


                this.right = Object.assign({}, clonedRight);
                this.editMode = true;
                this.disabled = !this.updateRight;

                this.showRightModal = true;
            },

            onDeleteRight(right) {
                this.right = Object.assign({}, right);
                this.showDeletionModal = true;
            },

            initializeRights() {
                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "RightDelete") {
                        this.deleteRight = true;
                    }

                    if (right.right === "RightUpdate") {
                        this.updateRight = true;
                    }
                });
            },

            initialize() {

                if (this.appRight) {
                    rightinterface.getAppRights(rights => {
                        this.rights = rights;
                    })
                } else {
                    rightinterface.getPoolGroupRights(rights => {
                        this.rights = rights;
                    })
                }
            },

            closeAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        },

        computed: {
            getRightTypeHeader: function () {
                return this.appRight ? "App rights" : "Pool group rights";
            }
        }
    };
</script>

<style>
    .width-right-name{
        width: 30%
    }
    .width-right-description {
        width: 30%
    }
</style>


// WEBPACK FOOTER //
// src/components/common/rights/RightList.vue